import React from 'react'

const caution = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <circle cx="10" cy="10" r="9.25" stroke="#FFF" strokeWidth="1.5" />
      <path fill="#FFF" fillRule="nonzero" d="M11 15.075H9V13.2h2v1.875zm-.113-3.75H9.012L8.7 5.7h2.5l-.313 5.625z" />
    </g>
  </svg>
)

export default caution
